import React from 'react';

class Spinner extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="text-center">
                    <img src="/images/spinner.gif" alt="..." />
                </div>
            </React.Fragment>
        );
    }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/layouts/public/spinner/Spinner.js